"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _SourceListImageFileItemBody = require("./SourceListImageFileItemBody.styled");
var _ = require("../..");
var SourceListImageFileItemBody = function SourceListImageFileItemBody(_ref) {
  var value = _ref.value,
    title = _ref.title;
  return _react["default"].createElement(_SourceListImageFileItemBody.ImageViewer, null, value.url && _react["default"].createElement("img", {
    src: value.url,
    alt: title
  }), !value.url && _react["default"].createElement(_.TranscodeProcessing, {
    status: "PROCESSING",
    tooltipText: "This file is being scanned and will be available shortly.",
    theme: "light"
  }));
};
SourceListImageFileItemBody.propTypes = {
  value: _propTypes["default"].object,
  title: _propTypes["default"].string
};
var _default = exports["default"] = SourceListImageFileItemBody;